import { ORDER_STATUS, statusMapping } from "./enums";

export const reverseStatusLookup = (statusValue) => {
  const entry = Object.entries(ORDER_STATUS).find(
    ([, value]) => value === statusValue
  );
  return entry ? statusMapping[entry[0]] : statusValue;
};

export const StatusBadge = ({ status }) => {
  const statusColors = {
    // Modern, vibrant color palette
    // Order placement & initial states
    Pending: "bg-slate-100 text-slate-800 border border-slate-300",

    // Driver assignment flow
    "Driver-Assigned": "bg-violet-100 text-violet-800 border border-violet-300",
    "Driver-Approaching":
      "bg-indigo-100 text-indigo-800 border border-indigo-300",
    "Driver-Arrived": "bg-blue-100 text-blue-800 border border-blue-300",
    "Arrived-At-Location": "bg-cyan-100 text-cyan-800 border border-cyan-300",

    // Order progress flow
    "Picked-Up": "bg-sky-100 text-sky-800 border border-sky-300",
    "Driver-Departed": "bg-amber-100 text-amber-800 border border-amber-300",
    Delivered: "bg-[#23ad33]/10 text-[#23ad33] border border-[#23ad33]/30",

    // Cancellation states - variations of the same color family
    Cancelled: "bg-rose-100 text-rose-800 border border-rose-300",
    "Cancelled-By-Outlet": "bg-pink-100 text-pink-800 border border-pink-300",
    "Cancelled-By-Driver": "bg-red-100 text-red-800 border border-red-300",
    "Cancelled-By-Admin": "bg-rose-100 text-rose-800 border border-rose-300",

    // Error states
    "Nobody-Accepted": "bg-amber-50 text-amber-900 border border-amber-400",
  };

  const bgColor =
    statusColors[status] ||
    "bg-slate-100 text-slate-800 border border-slate-300";

  const entry = Object.entries(ORDER_STATUS).find(
    ([, value]) => value === status
  );

  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${bgColor}`}
    >
      {entry ? statusMapping[entry[0]] : status}
    </span>
  );
};

export const renderTruncatedText = (text, maxLength = 30) => {
  if (!text) return "N/A";
  return text.length > maxLength ? (
    <span title={text}>{text.substring(0, maxLength)}...</span>
  ) : (
    text
  );
};


